import { getNumberFromString } from './formatNumbers';

export default function convertUnitMoney(data, projectData) {
  if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
    if (data.hasOwnProperty('unit')) {
      switch (data.unit) {
        case '%': {
          const parentField = projectData?.[data?.derivedFrom];
          if (!parentField) return 0;
          return (
            (getNumberFromString(parentField) *
              getNumberFromString(data.value)) /
              100 || 0
          );
        }
        case 'yearly': {
          return getNumberFromString(data.value) / 12;
        }
        case 'amount':
        case 'monthly':
        default: {
          return getNumberFromString(data.value);
        }
      }
    }
  } else if (typeof data === 'string') {
    // return 0 if the value is 'DELETED' because we dont want to interfere with the calculations. the deleted key is used in the before after section to maintain the order of the fields and allow the user to add fields back after deleting them
    if (data === 'DELETED') return 0;
    return getNumberFromString(data);
  } else {
    return data;
  }
}
